import wNumb from "wnumb";

const moneyFormatter = (val, prefix) => {
  let format = wNumb({
    mark: ".",
    thousand: ",",
    prefix: prefix === false ? "" : "$ "
  });

  let value;
  let temp = +(val * 1).toFixed(2);

  if (temp) {
    value = format.to(temp);
  } else if (temp == 0 && prefix == false) {
    value = temp;
  } else {
    value = "$ 0";
  }
  return value;
};

export default moneyFormatter;



// WEBPACK FOOTER //
// ./src/components/common/moneyFormatter.js